module.exports = __webpack_public_path__ + "img/nature-59.06f9a32b.jpg";